module.exports = __webpack_public_path__ + "img/web_price_free.2eb93ae5.png";